import { useEffect, useState } from "react"
import { Modal, ModalId, useUIState } from "../../../../features/ui"
import { Lot, Product } from "../../../products"
import { Item } from "../../state/types"
import { OperationItemForm } from "./operationItemForm"
import { Discount } from "../../../common"

type Props = {
    defaultData?: Partial<Item>
    createMode?: boolean
    customerTypeId?: string
    branchId?: string
    withLots?: boolean
    priceLabel?: string
    discountLabel?: string
    discountHint?: string
    defaultPrice: (productId: string) => number
    defaultDiscounts?: (productId: string) => Promise<Discount[]>
    filterProducts?: (product: Product) => boolean
    filterLots?: (lot: Lot) => boolean
    withSpecialDiscount?: (data: Partial<Item>) => boolean
    onSubmit: (data: Partial<Item>) => void
}

export const OperationItemFormModal = (props: Props) => {
    const { defaultData, createMode, customerTypeId, branchId, withLots, priceLabel, discountLabel, discountHint, defaultPrice, defaultDiscounts, filterProducts, filterLots, withSpecialDiscount, onSubmit } = props
    const [key, setKey] = useState(0)
    const { openedModal } = useUIState()

    useEffect(() => setKey(key + 1), [openedModal])
    
    return (
        <Modal
            modalId={ModalId.OPERATION_ITEM_FORM}
            title="Agregar Producto"
            actions={[]}
            widthSize="l"
        >
            <OperationItemForm
                key={key}
                defaultData={defaultData}
                createMode={createMode}
                customerTypeId={customerTypeId}
                branchId={branchId}
                withLots={withLots}
                withSpecialDiscount={withSpecialDiscount}
                priceLabel={priceLabel}
                discountLabel={discountLabel}
                discountHint={discountHint}
                defaultPrice={defaultPrice}
                defaultDiscounts={defaultDiscounts}
                filterProducts={filterProducts}
                filterLots={filterLots}
                onSubmit={onSubmit}
            />
        </Modal>
    )
}
